import React from "react";

interface TextInputProps {
    label: string;
    name: string;
    value?: any;
    type?: string;
    readOnly?: boolean;
    onChange: (value: any) => void
}
interface TextInputState {
    value: string;
    type: string;
}
export class TextInput extends React.Component<TextInputProps, TextInputState> {
    constructor(props: TextInputProps) {
        super(props);
        this.state = {
            value: this.props.value || "",
            type: this.props.type ? this.props.type : "text"
        };
        this.handleChange = this.handleChange.bind(this);
    }

    static getDerivedStateFromProps(nextProps: TextInputProps, prevState: TextInputState): any {
        if (prevState.type !== nextProps.value) {
            return { value: nextProps.value };
        }
    }

    handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        const value = event.target.value;
        if (!value || value !== this.state.value) {
            this.setState({ value });
            this.props.onChange(value);
        }
    }
    render() {
        return (
            <label>
                <span className="field">{this.props.label}</span>
                <input
                    name={this.props.name}
                    type={this.state.type}
                    value={this.state.value}
                    readOnly={this.props.readOnly}
                    placeholder={this.props.label}
                    onChange={this.handleChange} />
            </label>
        );
    }
}
